import Vue from 'vue'
import Vuex from 'vuex';
import App from './App.vue'
import router from './router'
import './registerServiceWorker'
import TricicloDashboard from './plugins/triciclo-dashboard'
import store from './store/store'; // Certifique-se de que este é o caminho correto para o seu arquivo de store
import VueGoogleCharts from 'vue-google-charts';
import VueCompositionApi from '@vue/composition-api';

Vue.use(Vuex);
Vue.config.productionTip = false
Vue.config.silent = true

Vue.use(TricicloDashboard)

Vue.use(VueGoogleCharts);

Vue.use(VueCompositionApi);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
